{
  "navigation": {
    "dashboard": "Dashboard",
    "operations": "Operations"
  },
  "sidebar": {
    "title": "Sidebar",
    "description": "Navigation menu",
    "toggleHint": "Toggle navigation (Ctrl/Cmd+B)",
    "toggle": "Toggle sidebar"
  },
  "user": {
    "notifications": "Notifications",
    "systems": "Systems",
    "lightTheme": "Light mode",
    "darkTheme": "Dark mode"
  },
  "documentTitle": "Fuel - Operations",
  "nav": {
    "changeBranch": "Change branch",
    "systems": "Systems"
  }
}
